<script lang="ts">
	export let value = "";
	export let backgroundColor = "#f0f0f4";
	export let flexibleHeight = false;
	export let placeholder = "";

</script>

<div
	class:displayPlaceholder={value.length === 0}
	placeholder={placeholder}
	on:change
	on:input
	class:flexible={flexibleHeight}
	bind:textContent={value}
	contenteditable
	style={`background-color : ${backgroundColor}`} />

<style lang="scss">
	div {
		position: relative;
		box-sizing: border-box;
		width: 100%;
		border-radius: 5px;
		padding: 6px 10px;
		font-size: inherit;
		line-height: inherit;
		font-weight: inherit;
		color: inherit;
		transition: box-shadow 0.1s;

		&.displayPlaceholder::before {
			position: absolute;
			content: attr(placeholder);
			display: block; /* For Firefox */
			color: var(--default-disabled-btn-1);
			font-weight: 300;
		}
		&:not(.flexible) {
			height: 100%;
			overflow-y: auto;
		}

		&.flexible {
			flex-grow: 1;
			min-height: 100%;
		}

		&:focus {
			outline: none;
			box-shadow: 0 0 0 2pt var(--signature-blue);
		}
	}

</style>
